import { IconButton, IconButtonProps } from "@mui/material";

function PageHeaderIconButton(props: IconButtonProps) {
  const { children } = props;

  return <IconButton {...props}>{children}</IconButton>;
}

export default PageHeaderIconButton;
